// /**
//  * Order detail -CSV
//  */

// React
import React from 'react';
import {CSVLink} from 'react-csv';
import {Order} from '../orders/interfaces';
import {mdiArrowCollapseDown} from '@mdi/js';
import Icon from '@mdi/react';

type Props = {
  data: Order[];
  loading: boolean;
};

function CSV(props: Props) {
  const flattData = (data: any) => {
    return data.map((item: any) => {
      return {
        orderItemId: item.id,
        productName: item.productName,
        productCode: item.productCode,
        variantCode: item.variantCode,
        variantId: item.variantId,
        amount: item.amount,
      };
    });
  };

  return (
    <CSVLink
      data={flattData(props.data)}
      filename="Orders.csv"
      style={{
        backgroundColor: 'white',
        padding: '5px',
        color: '#2F4858',
        marginLeft: '5px',
        textDecoration: 'none',
        border: '1px solid #2F4858',
        borderRadius: '5px',
        fontSize: '16px',
      }}
    >
      <Icon
        path={mdiArrowCollapseDown}
        size={'20px'}
        style={{paddingTop: '5px', paddingLeft: '3px'}}
      />
      CSV
    </CSVLink>
  );
}

export default CSV;
